export default {
  title: {
    regular: 'Modificateurs standards pour les produits',
    meal: 'Créez votre offre repas',
    upsell: 'Créez votre groupe de vente additionnelle',
  },
  description: {
    regular:
      "Sélectionnez les modificateurs à inclure dans le nouveau groupe s'ils existent déjà dans un autre groupe. Vous pouvez aussi créer le groupe et ajouter des modificateurs plus tard.",
    meal: "Sélectionnez les produits à inclure dans votre offre repas. S'ils n'existent pas encore, créez-les sur la page « Gérer les menus ». Assurez-vous d'associer l'offre repas aux bons produits dans la section « Modificateurs » du créateur de produits.",
    upsell:
      "Sélectionnez les produits à inclure dans votre groupe de vente additionnelle. S'ils n'existent pas encore, créez-les sur la page « Gérer les menus ». Assurez-vous d'associer l'élément de vente additionnelle aux bons produits dans la section « Modificateurs » du créateur de produits.",
  },
  fields: {
    name: {
      label: 'Nom',
      placeholder: 'Saisir le nom du groupe',
    },
    max_quantity: {
      label: 'Quantité max.',
      placeholder: 'Quantité max. de modificateurs',
    },
    is_required: {
      label: 'Obligatoire',
    },
  },
  labels: {
    visible: 'Visible',
    hidden: 'Masqué',
    multiply: 'Multipliable',
  },
  buttons: {
    save: 'Enregistrer',
    close: 'Fermer',
  },
  toasts: {
    modifier_group_got_created: 'Groupe de modificateurs créé',
    modifier_group_got_updated: 'Groupe de modificateurs mis à jour',
  },
};
